import { render, staticRenderFns } from "./currencies.vue?vue&type=template&id=5d312d6d&scoped=true&"
import script from "./currencies.vue?vue&type=script&lang=ts&"
export * from "./currencies.vue?vue&type=script&lang=ts&"
import style1 from "./currencies.vue?vue&type=style&index=1&id=5d312d6d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d312d6d",
  null
  
)

export default component.exports